

import React from 'react';
import LogoVideo from '../assets/Logo.mp4';
import { Link } from "react-router-dom";






const Header = () => {
  return (
    <header className='pt-3'>
      <div className='container mx-auto'>
        <div className='flex justify-between items-center'>
          {/* Video logo */}
          <Link to="/">
            <div className="rounded-full overflow-hidden w-20 h-20 md:w-32 md:h-32">
              <video
                src={LogoVideo}
                autoPlay
                muted
                playsInline
                className='w-full h-full object-cover object-center'
              />
            </div>
          </Link>
          {/* Menu/Close button */}
          <Link to='/work-with-me'>
            <button className='btn btn-sm'>
              Work with me
            </button>

          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;



